export const version = '5.7.3';
export const buildDate = '2026-08-31T21:40:27.063Z';
export const commitHash = 'bb7b1d2';